import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X, Flame, Building2, Send } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";
import { useConfig } from "../context/ConfigContext";

const baseLinks = [
  { to: "/", label: "Home" },
  { to: "/verhaal", label: "Het Verhaal" },
  { to: "/shop", label: "Shop" },
  { to: "/zakelijk", label: "Zakelijk" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const { totals, setOpen } = useCart();
  const { ecommerceEnabled } = useConfig();
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const links = baseLinks;

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 w-full border-b border-[var(--tha-border)]"
      style={{
        background: "rgba(5,5,5,0.6)",
        backdropFilter: "blur(20px)",
      }}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8 py-4">
        <Link
          to="/"
          data-testid="brand-logo"
          className="flex items-center gap-2 group"
        >
          <span className="font-display text-2xl tracking-tight text-white group-hover:text-[var(--tha-red)] transition-colors">
            TIK HEM <span className="neon-red-text">AAN!</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm uppercase tracking-widest font-mono-x transition-colors ${
                  isActive
                    ? "text-[var(--tha-red)]"
                    : "text-[var(--tha-muted)] hover:text-white"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {ecommerceEnabled && (
            <button
              data-testid="open-cart-button"
              onClick={() => setOpen(true)}
              className="relative btn-ghost-red px-4 py-2.5 flex items-center gap-2"
              aria-label="Winkelmandje openen"
            >
              <ShoppingBag size={16} />
              <span className="text-xs font-mono-x tracking-widest">CART</span>
              {totals.count > 0 && (
                <span
                  data-testid="cart-count-badge"
                  className="absolute -top-2 -right-2 min-w-[20px] h-5 px-1 flex items-center justify-center bg-[var(--tha-red)] text-black text-[10px] font-bold rounded-full"
                >
                  {totals.count}
                </span>
              )}
            </button>
          )}

          {ecommerceEnabled ? (
            <button
              data-testid="nav-bestel-btn"
              onClick={() => navigate("/shop")}
              className="hidden sm:inline-flex btn-red px-5 py-2.5 font-display tracking-wide text-sm"
            >
              BESTEL NU
            </button>
          ) : (
            <button
              data-testid="nav-zakelijk-btn"
              onClick={() => navigate("/zakelijk")}
              className="hidden sm:inline-flex btn-red px-5 py-2.5 font-display tracking-wide text-sm items-center gap-2"
            >
              <Building2 size={14} /> ZAKELIJK
            </button>
          )}

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-white"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-[var(--tha-border)] bg-[#0a0a0a]"
        >
          <div className="flex flex-col px-5 py-4 gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-3 py-3 px-2 border-b border-[var(--tha-border)] last:border-0 text-sm uppercase tracking-widest font-mono-x ${
                    isActive ? "text-[var(--tha-red)]" : "text-white"
                  }`
                }
                end={l.to === "/"}
              >
                <Flame size={14} />
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
